var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconoHistoriaGris(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 85 81.5",
    style: {
      enableBackground: "new 0 0 85 81.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#63616C"
    },
    d: "M70.3,82.3H5.9c-3.7,0-6.5-2.9-6.5-6.5V26.5c0-4,3.4-7.3,7.3-7.3h15.5c4,0,7.3,3.4,7.3,7.3v3.9H70 c3.6,0,6.4,2.6,6.8,6.3c0,0,0,0.1,0,0.1v39C76.8,79.5,74,82.3,70.3,82.3z M6.7,21.8C4.2,21.8,2,24,2,26.5v49.3 c0,2.2,1.7,3.9,3.9,3.9h64.4c2.2,0,3.9-1.7,3.9-3.9V36.9c-0.3-2.3-2-3.9-4.2-3.9H28.2c-0.7,0-1.3-0.6-1.3-1.3v-5.2 c0-2.5-2.1-4.7-4.7-4.7H6.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#63616C"
    },
    d: "M69.5,82h-4.8c-0.7,0-1.3-0.6-1.3-1.3s0.6-1.3,1.3-1.3h4.8c2.8,0,5.2-1.8,5.8-4.3l7.3-26.3c0,0,0-0.1,0-0.1 c0.4-1,0.3-2.1-0.3-3c-0.6-0.9-1.5-1.4-2.6-1.4h-4.6c-0.7,0-1.3-0.6-1.3-1.3s0.6-1.3,1.3-1.3h4.6c1.9,0,3.7,0.9,4.8,2.5 c1.1,1.6,1.3,3.6,0.6,5.4l-7.3,26.2C77,79.4,73.5,82,69.5,82z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#63616C"
    },
    d: "M68,32.9c-0.7,0-1.3-0.6-1.3-1.3V3.5C66.7,2.7,66,2,65.2,2H18.7c-0.8,0-1.5,0.7-1.5,1.5v17 c0,0.7-0.6,1.3-1.3,1.3s-1.3-0.6-1.3-1.3v-17c0-2.2,1.9-4.1,4.1-4.1h46.5c2.2,0,4.1,1.9,4.1,4.1v28.1C69.3,32.3,68.7,32.9,68,32.9 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#63616C"
    },
    d: "M61.6,8h-13c-0.5,0-1-0.4-1-1s0.4-1,1-1h13c0.5,0,1,0.4,1,1S62.1,8,61.6,8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#63616C"
    },
    d: "M61.6,16H22.7c-0.5,0-1-0.4-1-1s0.4-1,1-1h38.9c0.5,0,1,0.4,1,1S62.1,16,61.6,16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#63616C"
    },
    d: "M61.6,22.9H33.2c-0.5,0-1-0.4-1-1s0.4-1,1-1h28.4c0.5,0,1,0.4,1,1S62.1,22.9,61.6,22.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#63616C"
    },
    d: "M39.8,67.8c-7.3,0-13.2-5.9-13.2-13.2s5.9-13.2,13.2-13.2S53,47.3,53,54.6S47.1,67.8,39.8,67.8z M39.8,43.4 c-6.2,0-11.2,5-11.2,11.2s5,11.2,11.2,11.2S51,60.8,51,54.6S46,43.4,39.8,43.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#63616C"
    },
    d: "M42.5,62.3H37c-0.4,0-0.8-0.4-0.8-0.8v-3.4H33c-0.4,0-0.8-0.4-0.8-0.8v-5.5c0-0.4,0.4-0.8,0.8-0.8h3.4v-3.4 c0-0.4,0.4-0.8,0.8-0.8h5.5c0.4,0,0.8,0.4,0.8,0.8v3.5h3.4c0.4,0,0.8,0.4,0.8,0.8v5.5c0,0.4-0.4,0.8-0.8,0.8h-3.4v3.4 C43.3,61.9,42.9,62.3,42.5,62.3z M37.9,60.6h3.9v-3.4c0-0.4,0.4-0.8,0.8-0.8H46v-3.9h-3.4c-0.4,0-0.8-0.4-0.8-0.8v-3.4h-3.9v3.4 c0,0.4-0.4,0.8-0.8,0.8h-3.4v3.9H37c0.4,0,0.8,0.4,0.8,0.8v3.4H37.9z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoHistoriaGris);
export default __webpack_public_path__ + "static/media/iconoHistoriaGris.b9dca6aa.svg";
export { ForwardRef as ReactComponent };